var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrategize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000106869934524529950860000016594663642053196186_);fill:url(#SVGID_00000106862049893172543730000001132549175769591224_);}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000049913322072277513530000002819451230407785356_);fill:url(#SVGID_00000029743234085254389740000015998542007085650601_);}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000017492099372378165970000005074206680345450422_);fill:url(#SVGID_00000148625550057563044470000015223697975685307798_);}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000046341606419835211230000008036286646087090326_);fill:url(#SVGID_00000024720023347020699680000014579913943604908441_);}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000132073611350021316000000003586783720197063318_);fill:url(#SVGID_00000160911397279993395220000015919759536574576538_);}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000124163806276287612530000003521165329111007922_);fill:url(#SVGID_00000138554928109722528930000016915321510731108781_);}\n\t\n\t\t.st6{clip-path:url(#SVGID_00000060717632512331405060000007507054016793346691_);fill:url(#SVGID_00000029005661724421166060000003037208057361759649_);}\n\t\n\t\t.st7{clip-path:url(#SVGID_00000007386206581399234660000001464645148206529929_);fill:url(#SVGID_00000070837626478056039090000003343642024547492281_);}\n\t\n\t\t.st8{clip-path:url(#SVGID_00000134947979618954104120000001893034142039416725_);fill:url(#SVGID_00000072988485378709772330000005623279562126898360_);}\n\t\n\t\t.st9{clip-path:url(#SVGID_00000106149810332209235540000006394259279459976364_);fill:url(#SVGID_00000087407856431055370340000009341971472241981829_);}\n\t\n\t\t.st10{clip-path:url(#SVGID_00000055682083369113641790000008929643249070542729_);fill:url(#SVGID_00000026842987220299330940000016891684611751418294_);}\n\t\n\t\t.st11{clip-path:url(#SVGID_00000128480920958736645350000005876939526397827488_);fill:url(#SVGID_00000153688631415223558260000014232707238619920828_);}\n\t\n\t\t.st12{clip-path:url(#SVGID_00000043435225834404834530000017218864084364777874_);fill:url(#SVGID_00000119823422189038776810000006807867302311505306_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M98.5,47.9c0,2.5,0.3,5,1.1,7.4c0.6,2,2.7,3.1,4.6,2.5c2-0.6,3.1-2.7,2.5-4.6c-0.5-1.7-0.7-3.5-0.7-5.3 c0-10.3,8.4-18.7,18.7-18.7c10.3,0,18.7,8.4,18.7,18.7v207.1c-12.5,6.8-23.3,8.4-32.3,4.9C97.2,254.4,92,238,92,237.9 c-0.6-2-2.7-3.1-4.7-2.5c-2,0.6-3.1,2.7-2.5,4.7c0.2,0.8,6.2,19.9,23.5,26.7c4,1.6,8.2,2.4,12.6,2.4c8.6,0,18-2.9,28.1-8.8 c1.2-0.7,1.9-1.9,1.9-3.2V47.9c0-14.4-11.7-26.2-26.2-26.2C110.2,21.7,98.5,33.4,98.5,47.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029748829929747672240000011884951977288144541_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165956857701230287820000010655891918799868814_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5241,
    y1: 301.8756,
    x2: 3.4759,
    y2: 301.8756,
    gradientTransform: "matrix(0 87.5599 87.5599 0 -26314.6777 165.4436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 84.2,
    y: 21.7,
    style: {
      clipPath: "url(#SVGID_00000029748829929747672240000011884951977288144541_)",
      fill: "url(#SVGID_00000165956857701230287820000010655891918799868814_)"
    },
    width: 66.6,
    height: 247.4
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000043456352781291158750000006561415966614763171_",
    d: "M62.7,72.5c0,16.5,13.4,29.9,29.9,29.9 c2.1,0,3.8-1.7,3.8-3.7c0-2.1-1.7-3.8-3.8-3.8c-12.4,0-22.4-10.1-22.4-22.4c0-12.4,10-22.4,22.4-22.4c2.8,0,5.6,0.5,8.2,1.5 c1.9,0.8,4.1-0.2,4.9-2.1c0.8-1.9-0.2-4.1-2.1-4.9c-3.5-1.4-7.1-2-10.9-2C76.2,42.6,62.7,56,62.7,72.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052087114664408785580000017196076214473590424_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000043456352781291158750000006561415966614763171_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024711901397469959450000004556473106742486447_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5241,
    y1: 301.4994,
    x2: 3.4759,
    y2: 301.4994,
    gradientTransform: "matrix(0 87.5599 87.5599 0 -26314.6777 165.4436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 62.7,
    y: 42.6,
    style: {
      clipPath: "url(#SVGID_00000052087114664408785580000017196076214473590424_)",
      fill: "url(#SVGID_00000024711901397469959450000004556473106742486447_)"
    },
    width: 43.7,
    height: 59.8
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000018951883786272291190000006960585094448553130_",
    d: "M38.7,106c0,15.4,15.1,30.4,30.4,30.4 c2.1,0,3.7-1.7,3.7-3.7c0-2.1-1.7-3.7-3.7-3.7C58,129,46.2,117.2,46.2,106c0-11.2,9.1-20.3,20.3-20.3c2.1,0,3.7-1.7,3.7-3.7 c0-2.1-1.7-3.7-3.7-3.7C51.2,78.3,38.7,90.7,38.7,106"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018227045387765985830000018287365426991139739_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018951883786272291190000006960585094448553130_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164504368391147300930000007179742817315431864_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5241,
    y1: 301.171,
    x2: 3.4759,
    y2: 301.171,
    gradientTransform: "matrix(0 87.5599 87.5599 0 -26314.6777 165.4436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38.7,
    y: 78.3,
    style: {
      clipPath: "url(#SVGID_00000018227045387765985830000018287365426991139739_)",
      fill: "url(#SVGID_00000164504368391147300930000007179742817315431864_)"
    },
    width: 34.2,
    height: 58.2
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000114781419174557305770000000457940792835670968_",
    d: "M48.7,120.4c-10,4.6-16.4,14.7-16.4,25.7 c0,15,12.2,32.4,28.1,32.6c1,0.1,3.7,0.4,7,0.4c6.2,0,14.8-1,19.6-5.8c1.5-1.5,1.5-3.8,0-5.3c-1.5-1.5-3.8-1.5-5.3,0 c-3.8,3.8-14.6,4-20.6,3.2c-0.2,0-0.3,0-0.5,0c-11.5,0-20.8-13.7-20.8-25.1c0-8.1,4.7-15.5,12.1-18.9c1.9-0.9,2.7-3.1,1.8-5 c-0.6-1.4-2-2.2-3.4-2.2C49.8,120,49.3,120.1,48.7,120.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000174560252642146174000000017625426564141354884_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114781419174557305770000000457940792835670968_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040547489056602065820000010623342924229354940_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5241,
    y1: 301.2231,
    x2: 3.4759,
    y2: 301.2231,
    gradientTransform: "matrix(0 87.5599 87.5599 0 -26314.6777 165.4436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32.3,
    y: 120,
    style: {
      clipPath: "url(#SVGID_00000174560252642146174000000017625426564141354884_)",
      fill: "url(#SVGID_00000040547489056602065820000010623342924229354940_)"
    },
    width: 56.1,
    height: 59
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000129921658270855062130000016487652464870284675_",
    d: "M44.6,167.6c-0.4,0.5-9.1,12.1-6.3,26.2 c1.9,9.6,8.7,17.8,20,24.4c0.6,0.3,1.2,0.5,1.9,0.5c1.3,0,2.6-0.7,3.2-1.9c1-1.8,0.4-4.1-1.4-5.1c-9.4-5.4-14.9-11.9-16.4-19.3 c-2.2-10.7,4.8-20.1,4.9-20.2c1.2-1.7,0.9-4-0.7-5.2c-0.7-0.5-1.5-0.8-2.3-0.8C46.4,166.1,45.3,166.6,44.6,167.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063628734111400984110000018247579034886710410_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129921658270855062130000016487652464870284675_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002364455171192768400000001412234529665409968_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5241,
    y1: 301.1043,
    x2: 3.4759,
    y2: 301.1043,
    gradientTransform: "matrix(0 87.5599 87.5599 0 -26314.6777 165.4436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 166.1,
    style: {
      clipPath: "url(#SVGID_00000063628734111400984110000018247579034886710410_)",
      fill: "url(#SVGID_00000002364455171192768400000001412234529665409968_)"
    },
    width: 29,
    height: 52.5
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000031173131998773755030000006653031724930890653_",
    d: "M63.3,195.9c-0.5,0.9-12.1,21-4.2,39.3 c5.1,11.8,17,19.8,35.4,23.9c0.3,0.1,0.5,0.1,0.8,0.1c1.7,0,3.3-1.2,3.6-2.9c0.5-2-0.8-4-2.8-4.5c-15.9-3.5-26-10.1-30.1-19.5 c-6.5-14.8,3.6-32.4,3.7-32.6c1-1.8,0.4-4.1-1.3-5.1c-0.6-0.3-1.2-0.5-1.9-0.5C65.2,194.1,64,194.8,63.3,195.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134960912283698162990000017930859022622691495_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031173131998773755030000006653031724930890653_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173860988480841843060000007626495777894120103_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5241,
    y1: 301.3932,
    x2: 3.4759,
    y2: 301.3932,
    gradientTransform: "matrix(0 87.5599 87.5599 0 -26314.6777 165.4436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 51.1,
    y: 194.1,
    style: {
      clipPath: "url(#SVGID_00000134960912283698162990000017930859022622691495_)",
      fill: "url(#SVGID_00000173860988480841843060000007626495777894120103_)"
    },
    width: 48.3,
    height: 65.1
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000182493584079584477660000008534591283826129557_",
    d: "M117.6,141.8c-0.8,0-19.5,0.9-29.2,14 c-5.7,7.7-6.9,17.9-3.6,30.2c0.4,1.7,2,2.8,3.6,2.8c0.3,0,0.6,0,1-0.1c2-0.5,3.2-2.6,2.7-4.6c-2.7-10-1.9-18,2.4-23.8 c7.5-10.2,23.3-11,23.5-11c2.1-0.1,3.7-1.8,3.6-3.9c-0.1-1.9-1.6-3.6-3.5-3.6C117.8,141.8,117.7,141.8,117.6,141.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106130755820082813140000006320804768889650835_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000182493584079584477660000008534591283826129557_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039831595886217991520000015676542422683678088_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5241,
    y1: 301.6929,
    x2: 3.4759,
    y2: 301.6929,
    gradientTransform: "matrix(0 87.5599 87.5599 0 -26314.6777 165.4436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 81.5,
    y: 141.8,
    style: {
      clipPath: "url(#SVGID_00000106130755820082813140000006320804768889650835_)",
      fill: "url(#SVGID_00000039831595886217991520000015676542422683678088_)"
    },
    width: 40.1,
    height: 47
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000155856501108722397450000006726615875610345864_",
    d: "M110,116.7c-1.8,1-2.4,3.3-1.4,5.1 c0.7,1.2,1.9,1.9,3.2,1.9c0.6,0,1.3-0.2,1.9-0.5c20.8-12,30-1.4,30.4-0.9c1.3,1.6,3.6,1.9,5.2,0.6c1.6-1.3,1.9-3.6,0.6-5.3 c-0.4-0.5-6.2-7.7-18.2-7.7C126,109.9,118.7,111.6,110,116.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181799799146986797560000014289399746003350417_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155856501108722397450000006726615875610345864_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037658872626793455370000014877302559873677455_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5241,
    y1: 302.012,
    x2: 3.4759,
    y2: 302.012,
    gradientTransform: "matrix(0 87.5599 87.5599 0 -26314.6777 165.4436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 107.6,
    y: 109.9,
    style: {
      clipPath: "url(#SVGID_00000181799799146986797560000014289399746003350417_)",
      fill: "url(#SVGID_00000037658872626793455370000014877302559873677455_)"
    },
    width: 43.7,
    height: 14.2
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000130613768452052661470000007341483994711228574_",
    d: "M104.7,207.9c-1.8,1-2.5,3.3-1.5,5.1 c5,8.9,13.1,11.6,21.1,11.6c11.9,0,23.6-5.9,24.5-6.4c1.8-1,2.5-3.2,1.6-5c-1-1.8-3.2-2.6-5.1-1.6c-0.3,0.1-26.8,13.6-35.6-2.2 c-0.7-1.2-2-1.9-3.3-1.9C105.9,207.4,105.3,207.6,104.7,207.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183237325890332512690000009879907391756863930_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130613768452052661470000007341483994711228574_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155142324715026164590000000334579769620990378_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5241,
    y1: 301.9818,
    x2: 3.4759,
    y2: 301.9818,
    gradientTransform: "matrix(0 87.5599 87.5599 0 -26314.6777 165.4436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 207.4,
    style: {
      clipPath: "url(#SVGID_00000183237325890332512690000009879907391756863930_)",
      fill: "url(#SVGID_00000155142324715026164590000000334579769620990378_)"
    },
    width: 49.1,
    height: 17.8
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000181770559704908640550000005471578345523724180_",
    d: "M116.2,75.9c-1.9,0.9-2.7,3.1-1.9,5 c1.4,3,3.8,5.3,7.1,6.4c2,0.7,4.1,1,6.4,1c9.2,0,19.6-4.9,21-5.6c1.9-0.9,2.6-3.2,1.7-5c-0.9-1.9-3.1-2.6-5-1.7 c-5.5,2.7-16.2,6.2-21.5,4.3c-1.3-0.5-2.2-1.3-2.8-2.5c-0.6-1.4-2-2.2-3.4-2.2C117.2,75.6,116.7,75.7,116.2,75.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093163579584136846580000015054893744545760643_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181770559704908640550000005471578345523724180_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017499298562700112140000007771707857612003500_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5241,
    y1: 302.0458,
    x2: 3.4759,
    y2: 302.0458,
    gradientTransform: "matrix(0 87.5599 87.5599 0 -26314.6777 165.4436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 113.5,
    y: 75.1,
    style: {
      clipPath: "url(#SVGID_00000093163579584136846580000015054893744545760643_)",
      fill: "url(#SVGID_00000017499298562700112140000007771707857612003500_)"
    },
    width: 37.9,
    height: 13.2
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000169523081213851445520000011525365987554575752_",
    d: "M117.2,176.8c-1,1.8-0.4,4.1,1.4,5.1 c4.3,2.5,9.2,3.3,13.7,3.3c8.5,0,15.8-2.9,16.3-3.1c1.9-0.8,2.8-2.9,2.1-4.9c-0.8-1.9-3-2.8-4.9-2.1c-3.9,1.6-15.7,4.7-23.4,0.2 c-0.6-0.3-1.2-0.5-1.9-0.5C119.1,174.9,117.8,175.6,117.2,176.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155104885100716259180000005597643372789652409_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169523081213851445520000011525365987554575752_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142862961622835764950000004110063873571585153_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5241,
    y1: 302.0608,
    x2: 3.4759,
    y2: 302.0608,
    gradientTransform: "matrix(0 87.5599 87.5599 0 -26314.6777 165.4436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 116.1,
    y: 174.4,
    style: {
      clipPath: "url(#SVGID_00000155104885100716259180000005597643372789652409_)",
      fill: "url(#SVGID_00000142862961622835764950000004110063873571585153_)"
    },
    width: 35.2,
    height: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000146489430871116791230000004802091018814276505_",
    d: "M152.6,18.8c-2.1,0-3.7,1.7-3.7,3.7 c0,2.1,1.7,3.7,3.7,3.7h7.1L162,53c0.1,1.6,1.3,2.9,2.9,3.3c11.4,2.7,22,7.4,31.6,14.1c1.4,1,3.3,0.9,4.6-0.2l21.4-17.9l17.8,17.8 l-18.5,22.1c-1.1,1.2-1.2,3-0.3,4.4c6,9.5,10.1,19.8,12.3,30.7c0.3,1.6,1.7,2.9,3.3,3l29.1,2.5V158l-29.1,2.5 c-1.7,0.1-3,1.4-3.3,3c-2.2,10.9-6.3,21.2-12.3,30.7c-0.9,1.4-0.8,3.2,0.3,4.4l18.5,22.1l-17.8,17.8L201,220.6 c-1.3-1.1-3.2-1.2-4.6-0.2c-9.6,6.7-20.2,11.5-31.6,14.1c-1.6,0.4-2.7,1.7-2.9,3.3l-2.3,26.7h-6.4c-2.1,0-3.8,1.7-3.8,3.7 c0,2.1,1.7,3.7,3.8,3.7h9.8c1.9,0,3.6-1.5,3.7-3.4l2.4-27.4c10.4-2.7,20.2-7.1,29.1-13l21.8,18.3c1.5,1.2,3.7,1.1,5.1-0.2 l22.7-22.7c1.4-1.4,1.5-3.6,0.2-5.1l-19-22.6c5.2-8.8,9-18.2,11.3-28.1l29.8-2.6c1.9-0.2,3.4-1.8,3.4-3.7v-32.1 c0-1.9-1.5-3.6-3.4-3.7l-29.8-2.6c-2.3-9.9-6.1-19.3-11.3-28.1l19-22.6c1.2-1.5,1.1-3.7-0.2-5.1l-22.7-22.7 c-1.4-1.4-3.6-1.5-5.1-0.2l-21.8,18.3c-9-5.9-18.7-10.3-29.1-13l-2.4-27.4c-0.2-1.9-1.8-3.4-3.7-3.4H152.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147207139789115899360000010267057248801086648_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146489430871116791230000004802091018814276505_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043447972650809172770000015329184452656403374_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5241,
    y1: 302.9463,
    x2: 3.4759,
    y2: 302.9463,
    gradientTransform: "matrix(0 87.5599 87.5599 0 -26314.6777 165.4436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 148.9,
    y: 18.8,
    style: {
      clipPath: "url(#SVGID_00000147207139789115899360000010267057248801086648_)",
      fill: "url(#SVGID_00000043447972650809172770000015329184452656403374_)"
    },
    width: 124.8,
    height: 253.2
  })), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000142887767232097613030000000320737660236924583_",
    d: "M154.2,87.5c-0.4,2,1,4,3,4.4 c25.7,4.8,44.4,27.3,44.4,53.6c0,25.8-18.3,48.2-43.5,53.4c-2,0.4-3.3,2.4-2.9,4.4c0.4,1.8,1.9,3,3.7,3c0.2,0,0.5,0,0.8-0.1 c28.7-5.9,49.5-31.4,49.5-60.7c0-29.8-21.2-55.4-50.5-60.9c-0.2,0-0.4-0.1-0.7-0.1C156.1,84.4,154.5,85.6,154.2,87.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000089543971578900924410000014372935968566414487_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142887767232097613030000000320737660236924583_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036957059379566675440000004176915956116468125_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5241,
    y1: 302.6058,
    x2: 3.4759,
    y2: 302.6058,
    gradientTransform: "matrix(0 87.5599 87.5599 0 -26314.6777 165.4436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 153.8,
    y: 84.4,
    style: {
      clipPath: "url(#SVGID_00000089543971578900924410000014372935968566414487_)",
      fill: "url(#SVGID_00000036957059379566675440000004176915956116468125_)"
    },
    width: 55.3,
    height: 121.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategize);
export default __webpack_public_path__ + "static/media/strategize.6207791d73d6bd124c2358af749207a3.svg";
export { ForwardRef as ReactComponent };